import {loadHtmlContentBeforeElement} from '../lib/loadHtmlContentBeforeElement'

(function () {
    $(document).ready(function () {
        const $viewMoreSection = $('.next-list-row')
        const $nextButton = $viewMoreSection.find('button')
        const optionalDataAttributes = ['order', 'category']

        $nextButton.on('click', function (e) {
            e.preventDefault()

            let $button = $(this)
            let data = {
                offset: $button.attr('data-offset'),
            }

            optionalDataAttributes.forEach(attr => {
                if (typeof $button.data(attr) !== 'undefined') {
                    data[attr] = $button.data(attr)
                }
            });

            loadHtmlContentBeforeElement(window.fetch, $button.data('url'), data, $viewMoreSection)
                .then(response => {
                    if (!response.nextReqResults) {
                        return $nextButton.hide()
                    }

                    $button.attr('data-offset', response.offset + response.count)
                })
        })
    })
})()


// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/nextListRow.js